import React from 'react';
import SvgIcon from '../../../../utils/SvgIcon';
import { getCurrentWeekRange } from '../../../../utils/DateHelpers';
import { useJobsConfig } from '../../../../PortalJobListing/hooks/useJobsConfig';

type NextJobSummaryUpToFiveServicesProps = {
  weekSummary?: {
    scheduledTotal?: number;
    completedTotal?: number;
    rejectedTotal?: number;
    url?: string;
  };
  monthlySummary?: {
    completedTotal?: number;
    completedUrl?: string;
  };
};

const NextJobSummaryUpToFiveServices = ({ weekSummary, monthlySummary }: NextJobSummaryUpToFiveServicesProps) => {
  const { labels } = useJobsConfig();

  const scheduledTotal = weekSummary?.scheduledTotal ?? 0;
  const completedTotal = weekSummary?.completedTotal ?? 0;
  const rejectedTotal = weekSummary?.rejectedTotal ?? 0;

  const totalCollections = scheduledTotal + completedTotal + rejectedTotal;

  const currentWeek = getCurrentWeekRange();

  const weeklyCollectionsText = labels.weeklyCollectionsSentence.replace('{count}', totalCollections.toString());

  return (
    <div className="next-job-summary">
      <div className="next-job-summary__body">
        <div className="next-job-summary__header">
          <div className="next-job-summary__header-content">
            <div className="next-job-summary__title-wrapper">
              <div className="next-job-summary__title">{labels.thisWeek}</div>
              <div className="next-job-summary__title-date">{currentWeek}</div>
            </div>
          </div>
        </div>

        <div className="next-job-summary__week-summary">
          <div className="next-job-summary__week-summary-text">{weeklyCollectionsText}</div>
        </div>

        <div className="next-job-summary__status-cards">
          <div className="next-job-summary__status-card">
            <div className="next-job-summary__status-card-header">
              <div className="next-job-summary__status-card-indicator next-job-summary__status-card-indicator--scheduled" />
              <div className="next-job-summary__status-card-label">{labels.scheduled}</div>
            </div>
            <div className="next-job-summary__status-card-count">{scheduledTotal}</div>
          </div>

          <div className="next-job-summary__status-card">
            <div className="next-job-summary__status-card-header">
              <div className="next-job-summary__status-card-indicator next-job-summary__status-card-indicator--completed" />
              <div className="next-job-summary__status-card-label">{labels.completed}</div>
            </div>
            <div className="next-job-summary__status-card-count">{completedTotal}</div>
          </div>

          <div className="next-job-summary__status-card">
            <div className="next-job-summary__status-card-header">
              <div className="next-job-summary__status-card-indicator next-job-summary__status-card-indicator--rejected" />
              <div className="next-job-summary__status-card-label">{labels.rejected}</div>
            </div>
            <div className="next-job-summary__status-card-count">{rejectedTotal}</div>
          </div>
        </div>

        {weekSummary?.url && (
          <div className="next-job-summary__schedule-link">
            <a href={weekSummary.url} className="next-job-summary__schedule-link-text">
              {labels.viewSchedule}
            </a>
          </div>
        )}
      </div>

      {monthlySummary?.completedUrl && (
        <a href={monthlySummary.completedUrl} className="next-job-summary__footer">
          <div className="next-job-summary__footer-text">
            <span className="next-job-summary__footer-text-number">{monthlySummary.completedTotal ?? 0}</span>
            <span className="next-job-summary__footer-text-label">{labels.jobsCompletedMonth}</span>
          </div>
          <div className="next-job-summary__footer-icon">
            <SvgIcon viewBox="0 0 16 16" iconName="arrow-right-portal" className="next-job-summary__footer-icon-icon" />
          </div>
        </a>
      )}
    </div>
  );
};

export default NextJobSummaryUpToFiveServices;
